module.exports = __webpack_public_path__ + "static/img/104151.89bd19d0.png";